<div class="score-summary">
  <div class="tags">
    @if (tags.length > 0) {
      <mat-card
        appearance="outlined"
        class="tags_widget_root"
        [class.showInstance]="!isLEP"
      >
        <fz-game-card-tags
          [tags]="tags"
          [external]="true"
          variant="text"
        ></fz-game-card-tags>
        @if (!isLEP && eventCode) {
          <div class="event-code">
            <fz-event-number [eventCode]="eventCode"></fz-event-number>
            <fz-info matTooltip="Info about the card"></fz-info>
          </div>
        }
      </mat-card>
    }
  </div>
  <mat-card
    appearance="outlined"
    class="score-summary__card"
    [class.score-summary__card--lep]="isLEP"
  >
    <div class="score-summary__card__data score-summary__entry-fee">
      <span class="score-summary__card__data__key mat-label-medium">
        Entry Fee
      </span>
      <div class="score-summary__card__data__value">
        <fz-currency [value]="entryAmount"></fz-currency>
      </div>
    </div>

    <div class="score-summary__card__data score-summary__prize">
      <span
        class="score-summary__card__data__key mat-label-medium"
        [ngClass]="{ 'prize-top': isLEP }"
      >
        Prize
      </span>
      <div class="score-summary__card__data__value">
        @if (!isLEP && this.prizeValue) {
          <span>
            <fz-currency [value]="getPrize()"></fz-currency>
          </span>
        }
        @if (isLEP) {
          <div class="score-summary__card__data__value image">
            {{ eventScheduleDetails?.firstPrize?.prizeName }}
          </div>
        }
      </div>
    </div>

    @if (showSummary) {
      <div class="score-summary__card__data score-summary__zbo-referral">
        <span
          class="score-summary__card__data__key mat-label-medium"
          #tooltip="matTooltip"
          (click)="tooltip.toggle()"
          matTooltipClass="info-tooltip"
          matTooltip="If you have paid your ZBO subscription, you will receive a referral every time a user you invited plays a tournament."
          >ZBO Referral<img
            class="zbo-icon"
            (click)="tooltip.toggle()"
            src="{{ assetUrl }}/shared/svg/help.svg"
            alt="View"
          />
          <br />
        </span>
        <span class="score-summary__card__data__value">
          <fz-currency [value]="referralBonus()"></fz-currency>
        </span>
      </div>

      <div class="score-summary__card__data score-summary__b-score">
        <span class="score-summary__card__data__key mat-label-medium">
          Your Best Score
        </span>
        <span class="score-summary__card__data__value">
          {{ bestScore?.userBestScore || 0 }}
        </span>
      </div>
      <div class="score-summary__card__data score-summary__l-score">
        <span class="score-summary__card__data__key mat-label-medium">
          Your Last Score
        </span>
        <span class="score-summary__card__data__value">
          {{ bestScore?.userLastScore || 0 }}
        </span>
      </div>
    }
  </mat-card>
</div>
